<template>
	<v-card outlined>
		<v-card-title
			class = "secondary justify-center pa-0 body-1 white--text"
		>	
			<v-icon
				small
				color = "white"
				class = "mr-1"
			>
				
				mdi-application-settings-outline
			</v-icon>
			{{ $ml.get('streaming') }}
			
		</v-card-title>
		<v-card-text 
			class = "pt-2 pa-1"
		>
			<v-row
				dense
			>
				<!-- draw -->
				<v-col
					cols = "4"
				>
					<v-card
						outlined
					>
						<v-card-title
							class = "success caption pa-0 px-2 white--text"
						>
							<v-icon
								x-small
								color = "white"
								class = "mr-1"
							>
								
								mdi-border-all-variant
							</v-icon>
							{{ $ml.get('bbox_') }}
						</v-card-title>
						<v-card-text
							class = "pa-1"
						>
								
							<div 
								id 	  = "content_draw"
								style = "background: black" 
							>						
								<canvas 
									id = "draw_stream"
									style = "position: relative;"
								></canvas>	
							</div>
						</v-card-text>
					</v-card>
				</v-col>
				<v-col 
					cols = "8"
				>	
					<v-card
						outlined
					>
						<v-card-title
							class = "blue darken-3 px-2 caption py-0 white--text"
						>
							<v-icon
								x-small
								color = "white"
								class = "mr-1"
							>
								
								mdi-math-norm-box
							</v-icon>
							{{ $ml.get('parameters') }}
						</v-card-title>
						<v-card-text
							class = "pa-1"
						>											
							<v-row
								dense
							>	
								<template
									v-for = "(item_info, idx_info) of info_fields_setting"
								>
									
									<v-col
										:key = "idx_info"
										cols = "5"
									>
										
										<v-text-field
											v-show 		= "item_info.enable"
											dense
											outlined
											hide-details
											:type 	  = "item_info.type"
											v-model   = "info_setting[item_info.key]"
											:label 	  = "$ml.get(item_info.text)"
										></v-text-field>
											<!-- :disabled = "item_info.enable" -->

										<v-select
											v-show 		= "item_info.type == 'select'"
											hide-details
											outlined
											dense
											:items 		= "render_listed(item_info.list)"
											text-value  = "name"
											:label 		= "$ml.get(item_info.text)"
											v-model 	= "info[item_info.key]" 
										></v-select>
									</v-col>
								</template>
							</v-row>
						</v-card-text>
					</v-card>
					<v-card
						outlined
						v-show = "show"
					>
						<v-card-title
							class = "light-blue darken-1 px-2 caption py-0 white--text"
						>	
							<v-icon
								x-small
								color = "white"
								class = "mr-1"
							>
								
								mdi-clipboard-edit
							</v-icon>
							{{ $ml.get('register') }}
						</v-card-title>
						<v-card-text 
							class = "pa-1"
						>
							<v-row
								dense
							>	
								<template
									v-for = "(item_info, idx_info) of info_fields"
								>
									
									<v-col
										:key = "idx_info"
									>
										
										<v-text-field
											v-show 		= "item_info.enable"
											dense
											outlined
											hide-details
											:type 	  = "item_info.type"
											v-model   = "info[item_info.key]"
											:label 	  = "$ml.get(item_info.text)"
										></v-text-field>
											<!-- :disabled = "item_info.enable" -->

										<v-select
											v-show 		= "item_info.type == 'select'"
											hide-details
											outlined
											dense
											:items 		= "render_listed(item_info.list)"
											text-value  = "name"
											:label 		= "$ml.get(item_info.text)"
											v-model 	= "info[item_info.key]" 
										></v-select>

										<v-btn		
											v-if   = "item_info.type == 'btn'"									
											small
											:color = "item_info.color"
											@click = "actions(item_info.action)"
										>
											{{ item_info.text }}
										</v-btn>
									</v-col>
								</template>
							</v-row>
						</v-card-text>
					</v-card>

					
				</v-col>
				<v-col
					cols = "12"
				>
					<v-toolbar						    		
				    		dense
				    		height = "25"
				    		class  = "secondary white--text"
				    	>
				    	<v-icon
							small
							color = "white"
							class = "mr-1"
						>
							mdi-view-list
						</v-icon>
				    	<v-toolbar-title 
				    		class = "body-2"
				    	>
				    		{{ $ml.get('registered_colors_bbox') }}
				    	</v-toolbar-title>
				    	<v-btn
							fab
							right
							x-small
							absolute
							class  = "mb-5"
							@click = "show = !show"
							:color = "!show ? 'blue darken-1' : 'error'"
						>
							<v-icon
								x-small			
								color = "white"				
							>
								{{ !show ? 'mdi-plus' : 'mdi-close'}}
							</v-icon>
						</v-btn>
				    </v-toolbar>
						
					<v-divider></v-divider>
					<v-data-table
						dense
					    fixed-header
					    :headers 			 = "headers"
					 	:items 				 = "render_list"
					    class 				 = "elevation-5"			    
					    :hide-default-footer = "height < 56 ?  true : false"
					   	:options.sync 		 = "options"
					   	:server-items-length = "total"
					    :height 			 = "height + 'px'"
					    item-key 			 = "index"
					    :loading 			 = "loading"
					   	:footer-props 		 = "{
					   		showFirstLastPage 	: true,
					   		itemsPerPageOptions : [total], // 15, 30
					   		showCurrentPage 	: true
					   	}"				   	
					>	
						<template v-slot:item.size = "{ item }">
							<span>
								{{ item.size }}  <strong class = "primary--text">GB</strong>
							</span>							
						</template>
						<template v-slot:item.limit = "{ item }">
							<span>
								{{ item.limit }}  <strong class = "primary--text">GB</strong>
							</span>										
						</template>
						<template  v-slot:item.actions="{ item }">
							<v-icon
						        small
						        color="primary"
						        class="mr-2"
						        @click="actions('edit', item)"
						      >
						        mdi-pencil
						      </v-icon>
						      <v-icon
						        small
						        color="error"
						        @click="actions('del', item)"
						      >
						        mdi-delete
						      </v-icon>
						</template>
					</v-data-table>
				</v-col>
			</v-row>
		</v-card-text>
		<v-divider></v-divider>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				v-text = "$ml.get('update')"
				color  = "primary"
				x-small
				@click = "actions('update')"
			></v-btn>
			<v-btn
				v-text = "$ml.get('reset')"
				color  = "error"
				x-small
				@click = "actions('reset')"
			></v-btn>
		</v-card-actions>
	</v-card>
</template>
<script>
	import EventBus from '@/event-bus'
	import tags 	from '@/components/analytics/default_tags.js'
	export default{
		name 	: 'stream',
		props 	: [ 'info_to_component'],
		data    : (vm) => ({
			info 		 		: {},
			info_setting 		: {
				line_width : 1,
			},
			info_item 			 : {},
			info_fields_setting  : [
				{
					key  	: 'line_width',
					enable 	: true,
					text 	: 'line_width',
					text2 	: 'global',
					type 	: 'number',									
				},
			],
			info_fields	 : [
				
				{
					key  : 'tag',
					text : 'tags',
					type : 'select',
					list : 'list_tags',					
				},
				{
					key  : 'color',
					text : 'color',
					type : 'select',
					list : 'list_colors',						
				},
				{
					key    : 'register',
					text   : 'register',
					color  : 'primary',
 					type   : 'btn',		
 					action : 'add_color',			
				},
			],
			list_colors 	: ['blue', 'green', 'grey', 'yellow', 'red'],
			list_tags 		: ['person', 'gun', 'hands up', 'laptop', 'car'],
			ID_notification : 'stream',
			headers 	: [
				{
					text  : vm.$ml.get('tag'),
					value : 'tag',
				},
				{
					text  : 'Color',
					value : 'color',
				},
				{
					text  : vm.$ml.get('actions'),
					value : 'actions'
				}
			],
			height			: 100,
			options 		: { itemsPerPage : 30 },
			total 			: 0,
			list 			: [],
			loading			: false,
			context 		: null,
			color_context 	: 'red',			
			show 			: false,
			sizes_draw 		: {
				current_width  : 0 ,
				current_heidth : 0
			} 
		}), // data 

		created(){
			if (localStorage.getItem('streaming_paramaters')) {
				let info_get 	  =  JSON.parse(localStorage.getItem('streaming_paramaters'));
				if (info_get) {

					this.list 	 	  = info_get.list && info_get.list.length > 0 ? info_get.list : [];
					this.info_setting = info_get.parameters ? info_get.parameters : this.info_setting;  
					this.total 		  = info_get.list && info_get.list.length == 1 ? 1 : info_get.list.length - 1;
				}
			}
			if (tags) {
				let temp_tags = [];
				tags.forEach((tag)=>{
					if (!['analytic', 'motion'].includes(tag.key) ) {
						temp_tags.push(tag.key);
					}
				})
				this.list_tags = temp_tags;
			}
		}, // created	

		methods  : {

			actions(act, item, opt){
				console.log("actions : ", act)
				switch (act){

					case ('color') : {
						this.context.clearRect(0, 0, this.sizes_draw.current_width, this.sizes_draw.current_heidth);
						this.context.strokeStyle = item;
						this.context.strokeRect(42, 20, 300, 120); 
					}
					break;
					case ( 'line_width' ) : {
						this.context.clearRect(0, 0, this.sizes_draw.current_width, this.sizes_draw.current_heidth);
						this.context.lineWidth = item;
						this.context.strokeRect(42, 20, 300, 120); 
					}
					break;
					case ( 'update' ) : {
						let color_temp = 'red';
						let line 	   = 1;
						if (this.info_setting && this.info_setting.line_width) {
							line = parseInt(this.info_setting.line_width);
						}
						const info_set = this.info;
						if (info_set && info_set.color) {
							color_temp = info_set.color;
						}
						
						this.actions('color', color_temp);
						this.actions('line_width', line);						
						this.update();

					}
					break;
					case ( 'add_color' ) : {
						let info_add = this.info;
						this.list.push(info_add);						
						this.show 	 = false;
						// this.info = {};
						this.actions('update');

					}
					break;
					case ( 'reset' ) : {
						this.list 			= [];
						this.info_setting 	= {
							line_width : 1,
						}
						this.actions('color', 'red');
						this.actions('line_width', 1);
						if (localStorage.getItem('streaming_paramaters')) {
							localStorage.removeItem('streaming_paramaters')
						}
					};
					break;
					case ( 'edit' ) : {
						this.info_item  	= item;
						this.info 			= item;
						this.show 			= true;
						if (this.info_fields && this.info_fields.length > 0) {
							this.info_fields[2].text 	= 'update';
							this.info_fields[2].action 	= 'update_list';
						}

					}
					break;
					case ( 'del' ) : {
						this.info_item = item;
						EventBus.$emit('notifications_modal', {
							type : 'confirm_delete',
							ID 	 : this.ID_notification,
						})
					}
					break;
					case ( 'update_list' ) : {						
						if (this.info_fields && this.info_fields.length > 0) {
							this.info_fields[2].text 	= 'register';
							this.info_fields[2].action 	= 'add_color';
						}

						this.list.splice(this.list.indexOf(this.info_item), 1, this.info);
						this.actions('update');
					}
					break;
					default : {
						console.log("this not have a action")
					}

				} 
			}, // actions

			update(){
				if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_edit", "settings")){
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_edit") + " : " + this.$ml.get("settings"),
					});
					return false;
				};
				let info_up = {
					parameters 	: this.info_setting,
					list 	 	: this.list,
				}
				if (this.list && this.list.length > 0) {
					this.total = this.list.length == 1 ? 1 : this.list.length;
				}else{
					this.total = 0;
				}
				this.info = {};
				EventBus.$emit('notifications_modal', {
						type : 'updated',
					});
				this.save_local(info_up);

			}, // update

			del(item){
				if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_delete", "settings")){
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_delete") + " : " + this.$ml.get("settings"),
					});
					return false;
				}
				if (item) {
					this.list.splice(this.list.indexOf(item), 1);
					this.info_item 	= {};
					this.show 		= false;
					this.total --;
					if (this.list && this.list.length === 0) {
						this.total = 0;
					}else if (this.list && this.list.length === 1) {
						this.total = 1;

					}else if (this.list && this.list.length > 0){
						this.total = this.list.length;

					}
					EventBus.$emit('notifications_modal', {
						type : 'deleted',
					});
					const timer = setTimeout( ()=>{
						this.actions('update');					
						clearTimeout(timer);
					}, 1500)

				}
			}, // del

			save_local(item){
				localStorage.setItem('streaming_paramaters', JSON.stringify(item));

			}, // save local

			render_listed(list){
				return this[list];
			}, // render_listed
		}, // methods

		computed : {
			
			render_list: function(){
				return this.list;
			}, // render list

		}, // computed

		mounted(){

			let content 	 = document.getElementById("content_draw");
			let draw 		 = document.getElementById("draw_stream");
			let context_draw = null;

			if (draw.getContext("2d")) {
				
				let current_width 	= draw.width	= content.getBoundingClientRect().width,
					current_heidth  = draw.height	= content.getBoundingClientRect().height;

				this.sizes_draw = {
					current_width,
					current_heidth
				}
				
				context_draw = draw.getContext("2d");
				this.context = context_draw;
				// color random
				
				/*let o    = Math.round, r = Math.random, s = 255;
	            let ca   = 'rgba(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ',' + r().toFixed(1) + ',0.5)';
	            let num1 = o(r()*s)
	            let num2 = o(r()*s)
	            let num3 = o(r()*s)*/
                
                // color stroke / fill 
                context_draw.strokeStyle = this.color_context; //'rgba('+num1+','+num2+','+num3+',0.5)';
				
				// width line                
                context_draw.lineWidth   = this.info_setting.line_width;
				
				// draw Rect
				context_draw.strokeRect(42, 20, 300, 120); // fill

			}else{
				console.log("No get context 2d : ", this.ID_notification );
			}

			EventBus.$on('notifications_modal' + this.ID_notification, (action) =>{
				if (action) {
					this.del(this.info_item);
				}
			});


		}, // mounted
	};
</script>